export enum SharePortalLinksMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_SHAREPOINTLINKS = 'SET_SHAREPOINTLINKS',
  SET_ERROR = 'SET_ERROR'
}
